import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

type SoundCtx = {
  muted: boolean;
  toggleMute: () => void;
  setMuted: (v: boolean) => void;
};

const Ctx = createContext<SoundCtx | null>(null);
const LS_KEY = "gluedin:muted";

export const SoundProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [muted, setMuted] = useState<boolean>(() => {
    const saved = localStorage.getItem(LS_KEY);
    return saved === null ? true : saved === "true";
  });

  // Persist preference
  useEffect(() => {
    localStorage.setItem(LS_KEY, String(muted));
  }, [muted]);

  // Keep all mounted <video> elements in sync
  useEffect(() => {
    const nodes = document.querySelectorAll<HTMLVideoElement>(".video_player");
    nodes.forEach((v) => {
      v.muted = muted;
    });
  }, [muted]);

  const value = useMemo(
    () => ({
      muted,
      setMuted,
      toggleMute: () => setMuted((m) => !m),
    }),
    [muted]
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useSoundGlobal = () => {
  const ctx = useContext(Ctx);
  if (!ctx)
    throw new Error("useSoundGlobal must be used within <SoundProvider>");
  return ctx;
};
